import { render, staticRenderFns } from "./TableModule.vue?vue&type=template&id=21225184&scoped=true"
import script from "./TableModule.vue?vue&type=script&lang=js"
export * from "./TableModule.vue?vue&type=script&lang=js"
import style0 from "./TableModule.vue?vue&type=style&index=0&id=21225184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21225184",
  null
  
)

export default component.exports